import type { Company, GetCompaniesRequest } from '../types';
import { companyApi } from '../companyApi';
import { QueryKey } from '@shared/config';
import { useInfiniteRequest } from '@shared/config/query/hooks';
import { keepPreviousData } from '@tanstack/react-query';

export const useGetCompanies = ({ ...params }: GetCompaniesRequest) => {
  return useInfiniteRequest<Company>({
    queryKey: [QueryKey.GET_COMPANIES, params],
    queryFn: ({ pageParam }) =>
      companyApi.getCompanies({
        ...params,
        ...pageParam,
      }),
    initialPageParam: {
      perPage: params.perPage,
      page: params.page,
    },
    placeholderData: keepPreviousData,
  });
};
